// src/store/api/providerApi.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const customerApi = createApi({
  reducerPath: "customerApi",
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_API + "users/customer",
    prepareHeaders: (headers, { getState }) => {
      const token = getState()?.userSlice?.token; // ✅ بدون store
      if (token) headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  }),
  endpoints: (builder) => ({
    updateCustomer: builder.mutation({
      query: ({
        customerId,
        fullname,
        email,
        nationalCode,
        gender,
        birthDay,
        profileImg,
        skills,
        serviceCategories,
        description,
      } = {}) => {
        const payload = {};

        if (fullname != null) payload.fullname = fullname;
        if (email != null) payload.email = email;
        if (gender != null) payload.gender = gender; // ✅ fix
        if (nationalCode != null) payload.nationalCode = nationalCode;

        // ✅ Mongo Date: مستقیم Date object یا ISO string
        if (birthDay != null) payload.birthDay = birthDay;
        if (profileImg != null) payload.profileImg = profileImg;
        if (skills != null) payload.skills = skills;
        if (serviceCategories != null)
          payload.serviceCategories = serviceCategories;
        if (profileImg != null) payload.profileImg = profileImg;
        if (description != null) payload.description = description;

        return {
          url: `/${customerId}`,
          method: "PATCH",
          body: payload,
        };
      },
    }),
   
     getCustomers: builder.query({
      query: (query = {}) => {
        const { sort, filter, page = 1, limit = 10, id, search } = query;
        let url = "/front?";

        if (page) {
          url += `page=${page}`;
        }

        if (limit) {
          url += `&limit=${limit}`;
        }

        return {
          url: url,
          method: "GET",
        };
      },
    }),
      getOneCustomers: builder.query({
      query: (query = {}) => {
        const {  id} = query;
        let url = `${id}`;

  
        return {
          url: url,
          method: "GET",
        };
      },
    }),
  }),
});

export const { useUpdateCustomerMutation ,useGetCustomersQuery,useLazyGetOneCustomersQuery} = customerApi;
